<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="mainwarn" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="maindelete" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select [disabled]="SchoolLoading == true || loading == true || Saving == true" class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SchoolID"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="loading == true || Saving == true"> </caass-schoolselector>
			</div>
		</div>

		<div class="selector-item">
			<label class="leftMargin">Start Date:</label>
			<p-calendar
				[disabled]="loading == true || Saving == true"
				class="leftMargin"
				(ngModelChange)="onStartDateChange($event)"
				[(ngModel)]="StartDate"
				showIcon="true"
				showButtonBar="true"
				name="StartDate"
			></p-calendar>
			<label class="leftMargin">End Date:</label>
			<p-calendar
				[disabled]="loading == true || Saving == true"
				class="leftMargin"
				(ngModelChange)="onEndDateChange($event)"
				[(ngModel)]="EndDate"
				showIcon="true"
				showButtonBar="true"
				name="EndDate"
			></p-calendar>
		</div>

		<div class="selector-item">
			<div>
				<label>Active</label>
			</div>

			<div style="margin-left: 10px">
				<select
					[disabled]="loading == true || Saving == true"
					class="form-control"
					name="ActiveSelector"
					style="font-size: smaller"
					[(ngModel)]="Active"
					(ngModelChange)="onActiveChange($event)"
				>
					<option *ngFor="let r of lstActive" [ngValue]="r.ID">
						{{ r.Desc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading == true || Saving == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="loading == true || Saving == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddEvent()">Add Event</button>
		<button [disabled]="loading == true || Saving == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEditEvent()">Edit Event</button>
		<button [disabled]="loading == true || Saving == true" class="btn btn-primary" style="margin-left: 5px" (click)="onDeleteEvent()">Delete Event</button>
		<button [disabled]="loading == true || Saving == true" class="btn btn-primary" style="margin-left: 5px" (click)="onToggleEvent()">
			{{ ActiveText }}
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstEvent"
		[loading]="loading == true || Saving == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedEvent"
		dataKey="ID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--EventDescShort-->
				<th>
					<p-columnFilter type="text" field="EventDescShort" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--EventDescription-->
				<th>
					<p-columnFilter type="text" field="EventDescLong" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--EventLocation-->
				<th>
					<p-columnFilter type="text" field="EventLocation" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--EventDT-->
				<th>
					<!-- <p-columnFilter type="text" field="EventDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--EndDT-->
				<th>
					<!-- <p-columnFilter type="text" field="EndDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--RecurranceTypeDesc-->
				<th>
					<p-columnFilter field="RecurranceTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterRecurranceTypeDesc
								[ngModel]="value"
								[options]="lstRecurranceTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="EventDescShort">Event Code<p-sortIcon field="EventDescShort"></p-sortIcon></th>
				<th pSortableColumn="EventDescLong">Event Name<p-sortIcon field="EventDescLong"></p-sortIcon></th>
				<th pSortableColumn="EventLocation">Location<p-sortIcon field="EventLocation"></p-sortIcon></th>
				<th pSortableColumn="EventDT">Start Date<p-sortIcon field="EventDT"></p-sortIcon></th>
				<th pSortableColumn="EndDT">End Date<p-sortIcon field="EndDT"></p-sortIcon></th>
				<th pSortableColumn="RecurranceTypeDesc">Occurrence<p-sortIcon field="RecurranceTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Event>
			<tr [pSelectableRow]="Event" (dblclick)="onRowDblClick(Event)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Event[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
